import React, { useContext, useState } from "react";

import { MagnetIcon } from "fond/svg_icons";

import { MapContext } from "../MapProvider";

import { IButtonProps } from "./Toolbar";
import ToolbarToggleButton from "./ToolbarToggleButton";

const SnappingButton: React.FC<IButtonProps> = ({ icon, title }) => {
  const { drawControl } = useContext(MapContext);
  const [snap, setSnap] = useState(drawControl.current?.options?.snap || false);

  const handleOnChange = () => {
    // Always read the current value from drawControl to avoid stale state
    const currentValue = !!drawControl.current?.options?.snap;
    const newValue = !currentValue;

    setSnap(newValue);
    if (drawControl.current?.options) {
      drawControl.current.options.snap = newValue;
    }
  };

  return (
    <ToolbarToggleButton title={title || `${snap ? "Disable" : "Enable"} snapping`} value="snap" onChange={handleOnChange} selected={snap}>
      {icon || <MagnetIcon />}
    </ToolbarToggleButton>
  );
};

export default SnappingButton;
